// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router';
import Vuex from 'vuex';
import {mainStore} from './stores';
import Toasted from 'vue-toasted';
import {responseInterceptor,requestInterceptor} from "@/interceptors";
import Vuelidate from 'vuelidate';
import VeeValidate from 'vee-validate';
import VueSearchSelect from 'vue-search-select';
import DateRangePicker from 'vue2-daterange-picker';
import { MonthPicker } from 'vue-month-picker';
import { MonthPickerInput } from 'vue-month-picker';

Vue.use(Vuex);
Vue.use(Toasted,{duration:2000});

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
Vue.use(MonthPicker);
Vue.use(MonthPickerInput);
// Vue.component("VueSearchSelect", VueSearchSelect);
responseInterceptor();
requestInterceptor();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store:mainStore,
  router,
  template: '<App/>',
  components: {
    App
  }
});
